<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import type { JobOfferProps } from "./JobOfferProps.js";
	import Content from "../components/Content.svelte";
	import Link from "../components/Link.svelte";
	import footerImg from "../assets/images/footerHp.png?webp";
	import { benefitsNameMap } from "../../../core/schema/names/benefitsNameMap";
	import type { CareerBenefits } from "../../../core/schema/CareerBenefits.js";
	import SetOfBenefit from "../components/SetOfBenefit.svelte";
	import { getTranslate } from "../utils/getTranslate";
	import translations from "./JobOffer.translations.json";
	import CareerForm from "../components/CareerForm.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";

	const benefitOrder = Object.keys(benefitsNameMap) as (keyof CareerBenefits)[];

	const translate = getTranslate(translations);

	type $$Props = JobOfferProps;

	const { jobOffer } = $$restProps as $$Props;
	$: jobOfferMap = (Object.entries(jobOffer.benefits) as [keyof CareerBenefits, string[]][])
		.toSorted(([type], [secondType]) => benefitOrder.indexOf(type) - benefitOrder.indexOf(secondType))
		.filter(([_, benefits]) => benefits.length > 0);

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Layout footerImage={footerImg}>
	<div class="container mb-4 pt-40 lg:mb-28">
		<section>
			<h1 class="text-2lg mx-0 font-bold leading-[1.07] md:text-3xl lg:max-w-[75%] lg:text-5xl xl:max-w-[55%]">
				{nbspify(jobOffer.name)}
			</h1>
			{#if jobOffer.subtitle}
				<span class="text-2lg block lg:mt-16 lg:text-4xl">– {nbspify(jobOffer.subtitle)}</span>
			{/if}

			<div
				class="lg:[&>.ckeditor-content>p:first-child]:text-2lg mb-36 mt-36 lg:max-w-[75%] xl:max-w-[55%] [&>.ckeditor-content>p:first-child]:text-[2rem] [&>.ckeditor-content>p:first-child]:leading-normal [&>.ckeditor-content>p:first-child]:first:mb-20"
			>
				<Content content={jobOffer.perex} />
			</div>
		</section>
		<section class="my-32">
			<h2 class="mb-8 text-xl font-semibold lg:mb-16 lg:text-4xl">{translate("whatsWaitingForYouHeadline")}</h2>
			<Content content={jobOffer.description} />
		</section>
		<section class="lg:my-32">
			<h2 class="mb-8 text-xl font-semibold lg:mb-16 lg:text-4xl">{translate("whatDoWeExpectFromYouHeadline")}</h2>
			<div class="flex flex-col lg:flex-row lg:justify-between">
				<div>
					<Content content={jobOffer.descriptionExpectations} />
				</div>
				<div class="mt-16 lg:mt-0 lg:self-end">
					<Link animated asButton href="#careerForm" class="mx-auto lg:mr-0">{translate("sendCv")}</Link>
				</div>
			</div>
		</section>
	</div>
	<section class="bg-tertiary">
		<div class="container py-32 lg:py-64">
			<h2 class="mb-8 text-xl font-semibold lg:mb-36 lg:text-4xl">{translate("whatWeCanOfferYouHeadline")}</h2>

			<div class="flex flex-col gap-20">
				{#each jobOfferMap as [type, benefits], index}
					<SetOfBenefit {index} {type} {benefits} />
				{/each}
			</div>
		</div>
	</section>
	<section class="bg-tertiary relative py-16" id="careerForm">
		<div class="container" id="career-form">
			<div class="lg:max-w-[75rem]">
				<CareerForm />
			</div>
		</div>
	</section>
</Layout>
